import React, { useState, useEffect } from 'react';
import { Home, User, Cpu, Briefcase, Layers, MessageSquare } from 'lucide-react';

const Navbar = () => {
  const [activeNav, setActiveNav] = useState('#');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'skills', 'experience', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const height = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + height) {
            setActiveNav(`#${section === 'home' ? '' : section}`);
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: '#', icon: <Home size={18} strokeWidth={1.5} />, label: 'Home' },
    { id: '#about', icon: <User size={18} strokeWidth={1.5} />, label: 'About' },
    { id: '#skills', icon: <Cpu size={18} strokeWidth={1.5} />, label: 'Skills' },
    { id: '#experience', icon: <Briefcase size={18} strokeWidth={1.5} />, label: 'Services' },
    { id: '#projects', icon: <Layers size={18} strokeWidth={1.5} />, label: 'Projects' },
    { id: '#contact', icon: <MessageSquare size={18} strokeWidth={1.5} />, label: 'Contact' },
  ];

  return (
    <nav className="fixed bottom-6 md:top-6 md:bottom-auto left-1/2 -translate-x-1/2 z-50">
      <div className="flex items-center gap-1 sm:gap-2 px-2 py-1.5 bg-[#0d1117]/60 backdrop-blur-xl border border-white/10 rounded-full shadow-[0_8px_32px_rgba(0,0,0,0.8)]">
        {navItems.map((item) => (
          <a
            key={item.id}
            href={item.id}
            onClick={() => setActiveNav(item.id)}
            className={`relative p-2.5 rounded-full transition-all duration-300 group flex items-center justify-center ${
              activeNav === item.id 
              ? 'text-white' 
              : 'text-slate-500 hover:text-white'
            }`}
          >
            {/* Active Background Glow - Tighter and perfectly round */}
            {activeNav === item.id && (
              <div className="absolute inset-0 bg-white/10 rounded-full scale-90 blur-[0.5px]" />
            )}
            
            {/* Subtle glow behind active icon */}
            {activeNav === item.id && (
              <div className="absolute inset-0 bg-[#4779c4]/10 rounded-full blur-md animate-pulse" />
            )}

            <div className="relative z-10 transition-transform duration-300 group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_rgba(71,121,196,0.8)]">
              {item.icon}
            </div>

            {/* Hover Glow Effect (Neon Dark Blue) */}
            <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 group-hover:bg-[#4779c4]/20 group-hover:shadow-[0_0_15px_rgba(71,121,196,0.6)] transition-all duration-300" />

            {/* Tooltip (Compact) */}
            <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 px-3 py-1.5 bg-[#0d1117]/90 dark:bg-[#0d1117]/90 backdrop-blur-md text-[10px] font-bold uppercase tracking-[0.2em] text-white dark:text-white rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none border border-white/10 dark:border-white/10 shadow-2xl translate-y-2 group-hover:translate-y-0 flex flex-col items-center gap-1 light:bg-white light:text-[#1a3a1a] light:border-green-200 light:shadow-green-900/10">
              {item.label}
            </div>
          </a>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
